const links=[
    {
        imgUrl:"/images/GalleryPhotos/image1.JPG",
        description:"Children's Day Celebration 2018"
    },
    {
        imgUrl:"/images/GalleryPhotos/image2.JPG",
        description:"Children's Day Celebration 2017"
    },
    {
        imgUrl:"/images/GalleryPhotos/image3.JPG",
        description:"Sports Event"
    },
    {
        imgUrl:"/images/GalleryPhotos/image4.JPG",
        description:"Music Event"
    },
    {
        imgUrl:"/images/GalleryPhotos/image5.JPG",
        description:"Prize Distribution"
    },
    {
        imgUrl:"/images/GalleryPhotos/image6.jpg",
        description:"Teacher's Day Celebration"
    },
    
]


export default links;
